"use strict";

const formatTime = seconds => {
  const formattedMinutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
  return `${formattedMinutes}:${formattedSeconds}`;
};
export { formatTime };
//# sourceMappingURL=time.mjs.map
